import { SearchHistory } from './SearchHistory'
import { withSearchHistory } from './withSearchHistory'

const ConnectedSearchHistory = withSearchHistory(SearchHistory)

export { ConnectedSearchHistory as SearchHistory }
